import React, { useRef, useState } from 'react';
import {
  Button,
  ButtonGroup, Paper, MenuItem, ClickAwayListener,
  Grow, Popper, MenuList,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPrint,
  faCaretDown,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import PrintDialog from './printDialog';

const options = ['Форма 1', 'Форма 2'];
const urlList = [
  '/api/household/print_f1/',
  '/api/household/print_f2/',
];

function PrintFormEditor({ id }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [modalOpened, setModalOpened] = useState(false);

  const handleMenuItemClick = (
    event: MouseEvent,
    index: number,
  ) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: Event) => {
    if (
      anchorRef.current
      && anchorRef.current.contains(event.target)
    ) {
      return;
    }

    setOpen(false);
  };

  const handleClick = () => {
    setModalOpened(true);
  };

  return (
    <>
      <ButtonGroup variant="outlined" ref={anchorRef} aria-label="split button">
        <Button
          size="small"
          onClick={handleClick}
          startIcon={<FontAwesomeIcon icon={faPrint} />}
        >
          {options[selectedIndex]}
        </Button>
        <Button
          size="small"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          startIcon={<FontAwesomeIcon icon={faCaretDown} />}
        />
      </ButtonGroup>
      <Popper
        sx={{
          zIndex: 1,
        }}
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option, index) => (
                    <MenuItem
                      key={option}
                      disabled={index === 3}
                      selected={index === selectedIndex}
                      onClick={(event) => handleMenuItemClick(event, index)}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      {modalOpened && (
      <PrintDialog
        param={id}
        printUrl={urlList[selectedIndex]}
        modalOpened={modalOpened}
        setModalOpened={setModalOpened}
      />
      )}
    </>

  );
}

PrintFormEditor.propTypes = {
  id: PropTypes.number.isRequired,
};

export default PrintFormEditor;
